<script>
  export let tab_options // {value:'Value', display:'[html]Display'}
  export let selected_tab
  export let flush = false
</script>

<ul class:flush>
  {#each tab_options as tab_option}
    <li 
      on:click={() => selected_tab = tab_option.value}
      class:active={String(selected_tab) === String(tab_option.value)}>
      {@html tab_option.display}
    </li>
  {/each}
</ul>

<style>
	ul {
    padding: 1rem 1rem 0;
    background-color: var(--c-nav-bg);
  }
  ul.flush {
    margin: 0 -3rem 2rem;
    padding: 0 2rem 0;
    background-color: transparent;
  }
  li {
    display: inline-block;
    padding: 1rem;
    color: var(--c-text-faded);
    cursor: default;
  }
  li:not(.active):hover {
    cursor: pointer;
    color: var(--c-text);
  }
  li.active {
    color: var(--c-accent);
    background-color: var(--c-content-bg);
  }

  ul.flush li.active {
    background-color: var(--c-nav-bg);
  }
</style>